const REDACTION_PATTERNS = [
  /api[_-]?key/i,
  /secret/i,
  /token/i,
  /password/i,
  /private[_-]?key/i,
  /client[_-]?secret/i,
  /access[_-]?key/i,
  /firebase/i,
  /oauth/i,
  /auth[_-]?token/i,
  /bearer\s+[a-z0-9\-_]+/i,
];

export const MAX_REPO_FILE_SIZE = 200_000;
export const CODE_PREVIEW_FILE_TYPES = [
  '.ts',
  '.tsx',
  '.js',
  '.jsx',
  '.json',
  '.md',
  '.css',
  '.scss',
  '.html',
  '.txt',
  '.yml',
  '.yaml',
];

export const decodeBase64 = (input: string) => {
  if (typeof window !== 'undefined' && typeof window.atob === 'function') {
    return window.atob(input);
  }
  if (typeof Buffer !== 'undefined') {
    return Buffer.from(input, 'base64').toString('utf-8');
  }
  return input;
};

export const sanitizeContent = (content: string) => {
  const lines = content.split('\n');
  let redactedCount = 0;
  const sanitized = lines.map((line) => {
    if (REDACTION_PATTERNS.some((pattern) => pattern.test(line))) {
      redactedCount += 1;
      if (line.includes(':')) {
        const [prefix] = line.split(':');
        return `${prefix}: [redacted]`;
      }
      if (line.includes('=')) {
        const [prefix] = line.split('=');
        return `${prefix}= [redacted]`;
      }
      return '[redacted]';
    }
    return line;
  });
  return { content: sanitized.join('\n'), redactedCount };
};

const crcTable = (() => {
  const table = new Uint32Array(256);
  for (let i = 0; i < 256; i += 1) {
    let c = i;
    for (let j = 0; j < 8; j += 1) {
      c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
    }
    table[i] = c >>> 0;
  }
  return table;
})();

export const crc32 = (data: Uint8Array) => {
  let crc = 0 ^ -1;
  for (let i = 0; i < data.length; i += 1) {
    crc = (crc >>> 8) ^ crcTable[(crc ^ data[i]) & 0xff];
  }
  return (crc ^ -1) >>> 0;
};

export const encodeText = (text: string) => new TextEncoder().encode(text);

export const stripUndefinedFields = <T extends Record<string, unknown>>(value: T): T => {
  const entries = Object.entries(value).filter(([, fieldValue]) => fieldValue !== undefined);
  return Object.fromEntries(entries) as T;
};
